module.exports = __webpack_public_path__ + "img/16g021-11.ecad61f7.png";